/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { ActiveColumnService } from '@appLegacy/services/active-columns';
import { DatePositionValidator } from '@appLegacy/services/date-position-validator.factory';
import { FbdbRequests } from '@appLegacy/services/fbdb-requests';

//re-export proper class based so every upgrade can imported from here
export { ActiveColumnService, DatePositionValidator, FbdbRequests };

//A generic place for upgrading angularjs services to angular
//
//----------------------------
// STATE_PARAMS
//----------------------------
// extra bs required because we can't easily get at the class information since it's not our code
// Example:
// import FIREBASE_USERS_TOKEN
// constructor( @Inject(FIREBASE_USERS_TOKEN) firebaseUsers)

// export const FIREBASE_USERS_TOKEN = new InjectionToken('firebaseUsers');
// export function firebaseUsersFactory(i: any){
// 	return i.get('firebaseUsers');
// }
// export const firebaseUsersFactoryProvider = {
// 	provide: FIREBASE_USERS_TOKEN,
// 	useFactory: firebaseUsersFactory,
// 	deps: ['$injector']
// }

//template for things that don't require an InjectionToken (anything where we can access a definition class)
//----------------------------
// ClassName
//----------------------------
// import ClassName from "path"
// constructor( className: ClassName)

export function accessCheckFactory(i: any) {
	return i.get('accessCheck');
}

//----------------------------
// ActiveColumnService
//----------------------------
export function activeColumnServiceFactory(i: any) {
	return i.get('activeColumnService');
}
export const activeColumnServiceProvider = {
	provide: ActiveColumnService,
	useFactory: activeColumnServiceFactory,
	deps: ['$injector'],
};

//----------------------------
// DatePositionValidator
//----------------------------
export function datePositionValidatorFactory(i: any) {
	return i.get('DatePositionValidator');
}
export const datePositionValidatorProvider = {
	provide: DatePositionValidator,
	useFactory: datePositionValidatorFactory,
	deps: ['$injector'],
};

//----------------------------
// FbdbRequests
//----------------------------
export function fbdbRequestsFactory(i: any) {
	return i.get('fbdbRequests');
}
export const fbdbRequestsFactoryProvider = {
	provide: FbdbRequests,
	useFactory: fbdbRequestsFactory,
	deps: ['$injector'],
};

//--------------------------------------------------------------------------
//- Module definition
//--------------------------------------------------------------------------

import { NgModule } from '@angular/core';

@NgModule({
	imports: [],
	providers: [activeColumnServiceProvider, datePositionValidatorProvider, fbdbRequestsFactoryProvider],
})
export class AjsUpgradeModule {}
